import { AxiosResponse } from 'axios';

import { api } from 'tools/api-service';

import { GetPreferencesResponse } from './types/get-preferences.type';

export const getPreferences = async (): Promise<
    AxiosResponse<GetPreferencesResponse>
> => {
    const response = await api.get('/account/subscriptions');

    return response;
};
